import {createSlice} from "@reduxjs/toolkit";

const initialBrandsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  brandForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const brandsSlice = createSlice({
  name: "brands",
  initialState: initialBrandsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getbrandById
    brandFetched: (state, action) => {
      state.actionsLoading = false;
      state.brandForEdit = action.payload.brandForEdit;
      state.error = null;
    },
    // findbrands
    brandsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createbrand
    brandCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.brand);
    },
    // updatebrand
    brandUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.brand.id) {
          return action.payload.brand;
        }
        return entity;
      });
    },
    // deletebrand
    brandDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletebrands
    brandsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    }
  }
});
